import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { useContent } from "@/hooks/useData";

export const Advantages = () => {
  const { content } = useContent();
  const c = content.advantages;
  return (
    <section className="bg-[#F6F5F2]" data-testid="advantages-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4">
            <SectionHeading eyebrow={c.eyebrow} title={c.title} accent={c.accent} />
            <Reveal className="img-frame group aspect-[4/5] mt-10 hidden lg:block">
              <img src="https://images.pexels.com/photos/31817164/pexels-photo-31817164.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700" alt="Villa interior" className="w-full h-full object-cover" />
            </Reveal>
          </div>
          <div className="lg:col-span-7 lg:col-start-6 divide-y divide-[#ECEAE4] border-t border-[#ECEAE4]">
            {c.items.map((a, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <div className="py-8">
                  <h3 className="font-display text-2xl sm:text-3xl font-medium text-[#2C2A29]">{a.title}</h3>
                  <p className="text-[#5E5A54] font-light leading-relaxed mt-3 text-lg">{a.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
